import DescriptionDetails from "components/DescriptionDetails";
import FormFieldViewText from "components/FormFields/ViewText";
import { Space } from "components/icons/generated";
import MetaInfoListItem from "components/MetaInfoList/Item";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import FormField from "ds/components/Form/Field";
import { useShowFullDescriptionWithBackArrow } from "ds/components/FullDescriptionDrawer/useShowFullDescriptionWithBackArrow";
import { ExternalIntegration } from "types/generated";

type IntegrationDetailsDrawerProps = {
  integration: ExternalIntegration;
};

const IntegrationDetailsDrawer = createDrawer(({ integration }: IntegrationDetailsDrawerProps) => {
  const onOpenFullDescription = useShowFullDescriptionWithBackArrow(integration.description);

  return (
    <DrawerSimple>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="Integration details" />
        <DrawerCloseIcon />
      </DrawerHeader>
      <DrawerBody>
        <FormFieldViewText label="ID" value={integration.apiKey?.id || integration.id} withCopy />
        <FormFieldViewText label="Name" value={integration.name} />

        <FormField label="Space">
          <MetaInfoListItem
            icon={Space}
            linkText={integration.spaceDetails.name}
            href={`/spaces/${integration.spaceDetails.id}`}
          />
        </FormField>

        <DescriptionDetails
          description={integration.description}
          onOpenFullDescription={onOpenFullDescription}
        />
      </DrawerBody>
    </DrawerSimple>
  );
});

export const showIntegrationDetailsDrawer = createDrawerTrigger(IntegrationDetailsDrawer);
